class FetchAssetDetailsChoices {
  fetchThumbnails = false;

  thumbnailType = 'default';

  fetchInteractionMetrics = false;

  fetchVisibility = false;

  fetchDashboardAccess = false;

  docIds = [];

  constructor(
    fetchThumbnails = false,
    thumbnailType = 'default',
    fetchInteractionMetrics = false,
    fetchVisibility = false,
    fetchDashboardAccess = false,
  ) {
    this.fetchThumbnails = fetchThumbnails;
    this.thumbnailType = thumbnailType;
    this.fetchInteractionMetrics = fetchInteractionMetrics;
    this.fetchVisibility = fetchVisibility;
    this.fetchDashboardAccess = fetchDashboardAccess;
  }

  static fromObject({
    fetchThumbnails = false,
    thumbnailType = 'default',
    fetchInteractionMetrics = false,
    fetchVisibility = false,
    fetchDashboardAccess = false,
  }) {
    return new FetchAssetDetailsChoices(
      fetchThumbnails,
      thumbnailType,
      fetchInteractionMetrics,
      fetchVisibility,
      fetchDashboardAccess,
    );
  }
}

export default FetchAssetDetailsChoices;
